import dayjs from "dayjs";
import {
  CloseOutlined,
  CloseSquareOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Spin,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import CurrencyDenominationInfo from "./components/CurrencyDenominationInfo";
import CurrencySummary from "./components/CurrencySummary";
import Notiflix from "notiflix";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

function TellerBatch(props) {
  const { userData, rightBtn } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const [tellerStatus, setTellerStatus] = useState("O");
  const [summaryForm] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [denominationEntries, setDenominationEntries] = useState([]);
  const [summaryEntries, setSummaryEntries] = useState([]);

  const mockBalanceData = [
    { key: 1, currency: "USD", balance: 5000.0 },
    { key: 2, currency: "EUR", balance: 3500.0 },
    { key: 3, currency: "GBP", balance: 2800.0 },
  ];

  const balanceColumns = [
    { title: "Currency", dataIndex: "currency", key: "currency" },
    { title: "Balance", dataIndex: "balance", key: "balance" },
  ];

  const mockTellerTransactionData = [
    {
      key: 1,
      date: "2026-03-28",
      currencyCode: "USD",
      transactionDescription: "Teller Deposit",
      transactionAmount: 5000.0,
      transactionStatus: "Completed",
    },
    {
      key: 2,
      date: "2026-03-29",
      currencyCode: "EUR",
      transactionDescription: "Teller Withdrawal",
      transactionAmount: 1500.0,
      transactionStatus: "Pending",
    },
    {
      key: 3,
      date: "2026-03-30",
      currencyCode: "GBP",
      transactionDescription: "Teller Transfer",
      transactionAmount: 2800.0,
      transactionStatus: "Completed",
    },
  ];

  const tellerTransactionColumns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Currency Code", dataIndex: "currencyCode", key: "currencyCode" },
    {
      title: "Transaction Description",
      dataIndex: "transactionDescription",
      key: "transactionDescription",
    },
    {
      title: "Transaction Amount",
      dataIndex: "transactionAmount",
      key: "transactionAmount",
    },
    {
      title: "Transaction Status",
      dataIndex: "transactionStatus",
      key: "transactionStatus",
    },
  ];

  const currencyOptions = [
    { key: 1, label: "USD", value: "usd" },
    { key: 2, label: "EUR", value: "eur" },
    { key: 3, label: "GBP", value: "gbp" },
  ];

  const denominationOptions = [
    { key: 1, label: "100", value: "100" },
    { key: 2, label: "200", value: "200" },
    { key: 3, label: "500", value: "500" },
    { key: 4, label: "1000", value: "1000" },
  ];

  useEffect(() => {
    getBranchCode();
    form.setFieldValue("date", dayjs());
    form.setFieldValue("branchCode", "1");
    setLoading(false);
  }, []);

  const getBranchCode = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.TellerBatch}/template?officeId=1`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        // console.log(objList);
        // setBranchCode(objList)
        setLoading(false);
      }
    });
  };

  const getTemplate = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.TellerBatch}/template?officeId=1`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        // console.log(objList);
        // setBranchCode(objList)
        setLoading(false);
      }
    });
  };

  const onSubmit = (values) => {
    const payload = {
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      businesDate: values.date,
      branchCode: 1,
      batchUser: 1,
      batchStatus: tellerStatus,
      method: "POST",
      session,
    };

    console.log(payload);

    const url = `${apiConfig.TellerBatch}?officeId=1`;

    setLoading(true);
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Teller batch updated successfully");
        setLoading(false);
      }
    });
  };

  const handleOpenTill = () => {
    let label = "Do you really want to open branch batch?";

    Notiflix.Confirm.show(
      "Are you sure?",
      label,
      "Yes",
      "No",

      function () {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setTellerStatus("O");
        }, 1000);
      },

      function () {
        // No button
      },
    );
  };

  const handleCloseTill = () => {
    // let action = "Close  ";
    let label = "Do you really want to close branch batch?";

    Notiflix.Confirm.show(
      "Are you sure?",
      label,
      "Yes",
      "No",

      function () {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setTellerStatus("C");
        }, 1000);
      },

      function () {
        // No button
      },
    );
  };

  return (
    <MainLayout
      isEnableRightSidebar={false}
      pageItems={staticConfig.tellerBatchItems}
    >
      <TopContent
        pageTitle={labelConfig.manageTellerBatch}
        //  createPageTitle={labelConfig.createMoneyMarketBond}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row justify="end" style={{ marginBottom: 12 }}>
              <Button
                className="of-primaryBtnColor"
                style={{
                  width: "10%",
                }}
                icon={<UnorderedListOutlined />}
                onClick={handleOpenTill}
                disabled={tellerStatus === "O"}
              >
                Open Till
              </Button>
              <Button
                className="of-primaryBtnColor"
                style={{
                  width: "10%",
                  marginLeft: 10,
                }}
                shape="default"
                icon={<CloseSquareOutlined />}
                // htmlType="submit"
                onClick={handleCloseTill}
                disabled={tellerStatus === "C"}
              >
                Close Till
              </Button>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="date"
                  label={<Text strong>Date</Text>}
                  //   rules={[
                  //     {
                  //       required: true,
                  //       message: "Required Field",
                  //     },
                  //   ]}
                >
                  <DatePicker style={{ width: "100%", height: 44 }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="branchCode"
                  label={<Text strong>Branch Code</Text>}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={"1"}
                    style={{ width: "100%", height: 44 }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider />

            {tellerStatus === "O" && (
              <>
                <Title level={5}>Balance(s)</Title>
                <Table
                  dataSource={mockBalanceData}
                  columns={balanceColumns}
                  pagination={false}
                  size="small"
                />

                <CurrencyDenominationInfo
                  form={form}
                  currencyOptions={currencyOptions}
                  denominationOptions={denominationOptions}
                  denominationEntries={denominationEntries}
                  setDenominationEntries={setDenominationEntries}
                />
                {denominationEntries.length > 0 && (
                  <CurrencySummary
                    form={form}
                    currencyOptions={currencyOptions}
                    summaryEntries={summaryEntries}
                    setSummaryEntries={setSummaryEntries}
                  />
                )}

                {/* <Divider /> */}
                <Title level={5}>Teller Transaction(s)</Title>
                <Table
                  style={{ marginBottom: 24 }}
                  dataSource={mockTellerTransactionData}
                  columns={tellerTransactionColumns}
                  pagination={false}
                  size="small"
                />
              </>
            )}
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(TellerBatch);
